/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c6a9037f0eb60c1d42105e3fb21c9217cfc7e57a";
